export default function FSHeroV2() {
  const base = import.meta.env.BASE_URL;
  return (
    <section className="relative overflow-hidden min-h-[560px] flex items-center" style={{ background: "linear-gradient(135deg, #0a1e3a 0%, #0d2a4a 50%, #0a2440 100%)" }}>
      <div className="absolute inset-0 opacity-20">
        <img src={`${base}images/financial-services-v2/hero-bg.jpg`} alt="金融服务背景" className="w-full h-full object-cover object-top" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#0a1e3a]/95 via-[#0a1e3a]/70 to-transparent"></div>
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "linear-gradient(rgba(100,200,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(100,200,255,0.3) 1px, transparent 1px)", backgroundSize: "48px 48px" }}></div>

      <div className="relative max-w-7xl mx-auto w-full px-8 pt-20 pb-24">
        <div className="flex items-center gap-14">
        <div className="flex-1 min-w-0">
          <div className="inline-flex items-center gap-2 bg-cyan-400/10 border border-cyan-400/30 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-funds-line text-cyan-300 text-sm"></i>
            <span className="text-cyan-300 text-xs font-medium tracking-wide">空间数据驱动 · 精准拓客获客 · 赋能金融增长</span>
          </div>
          <h1 className="text-4xl font-bold text-white leading-tight mb-3">
            金融服务
            <span className="block text-xl font-normal text-cyan-300 mt-2">Financial Intelligence & Spatial Data Service</span>
          </h1>
          <p className="text-blue-100/80 text-sm leading-relaxed mb-5 max-w-lg">
            面向银行与金融机构，提供对公业务拓客、零售业务拓客、抵押贷款辅助、网点选址优化等核心能力，以空间数据驱动金融业务增长，构建数字化金融获客新引擎。
          </p>
          <div className="flex items-center gap-2 mb-5">
            {["客户画像", "业务拓客", "贷款辅助", "选址优化"].map((step, i) => (
              <span key={step} className="flex items-center gap-1.5 text-white/90 text-xs">
                <span className="w-5 h-5 rounded-full bg-cyan-400/20 border border-cyan-400/40 flex items-center justify-center text-cyan-300 text-xs font-bold">{i + 1}</span>
                {step}
              </span>
            ))}
          </div>
          <div className="flex items-center gap-2 mb-5">
            <span className="text-white/50 text-xs">面向客户:</span>
            {["银行", "金融机构"].map(c => (
              <span key={c} className="text-xs bg-cyan-400/15 border border-cyan-400/25 text-cyan-200 px-2.5 py-1 rounded-md whitespace-nowrap">{c}</span>
            ))}
          </div>
          <div className="flex items-center gap-4">
            <button className="bg-cyan-400 hover:bg-cyan-300 text-[#0a1e3a] font-semibold px-7 py-2.5 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap">申请试点方案</button>
            <button className="border border-white/30 hover:border-white/60 text-white px-7 py-2.5 rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-play-circle-line"></i>查看演示
            </button>
          </div>
        </div>

        <div className="flex-shrink-0 w-[500px]">
          <div className="bg-[#061530]/80 backdrop-blur-sm border border-white/15 rounded-2xl overflow-hidden">
            <div className="flex items-center justify-between px-4 py-3 border-b border-white/10 bg-white/5">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-rose-400"></div>
                <div className="w-2 h-2 rounded-full bg-amber-400"></div>
                <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
              </div>
              <span className="text-white/60 text-xs">金融业务平台 · 实时数据监控</span>
              <span className="text-cyan-300 text-xs bg-cyan-400/10 px-2 py-0.5 rounded-full">实时监控</span>
            </div>
            <div className="relative">
              <img src={`${base}images/financial-services-v2/dashboard-preview.png`} alt="金融服务管理面板" className="w-full h-52 object-cover object-top" />
              <div className="absolute top-3 left-3 bg-[#0a1a3a]/90 border border-white/15 rounded-lg px-3 py-2">
                <div className="text-xs text-white/60 mb-0.5">潜在客户</div>
                <div className="text-lg font-bold text-cyan-300">3,842 家</div>
              </div>
              <div className="absolute top-3 right-3 bg-[#0a1a3a]/90 border border-cyan-400/30 rounded-lg px-3 py-2">
                <div className="text-xs text-cyan-300 font-semibold">平均匹配度</div>
                <div className="text-base font-bold text-cyan-300">91 分</div>
              </div>
              <div className="absolute bottom-3 left-3 flex gap-1.5 flex-wrap">
                {["对公拓客", "零售拓客", "贷款辅助", "选址优化"].map(tag => (
                  <span key={tag} className="text-xs border border-white/20 bg-[#0a1a3a]/80 text-white/80 px-2.5 py-1 rounded-full">
                    <i className="ri-checkbox-circle-line text-cyan-400 text-xs mr-1"></i>{tag}
                  </span>
                ))}
              </div>
            </div>
            <div className="grid grid-cols-4 gap-0 border-t border-white/10">
              {[
                { value: "186", label: "今日新客", color: "text-amber-300" },
                { value: "2,340", label: "触达企业", color: "text-cyan-300" },
                { value: "94", label: "贷款辅助", color: "text-emerald-300" },
                { value: "12", label: "选址方案", color: "text-rose-300" },
              ].map(s => (
                <div key={s.label} className="px-3 py-3 text-center border-r border-white/10 last:border-0">
                  <div className={`text-sm font-bold ${s.color}`}>{s.value}</div>
                  <div className="text-white/40 text-xs mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>
  );
}
